export default class Messages {
  constructor(el) {
    // console.log('messages > constructor');
    this.el = el;
    // Get selectors
    this.selectorItems = this.el.getAttribute('data-messages-list-items');
    this.selectorView = this.el.getAttribute('data-message-view');
    this.selectorItemCaret = this.el.getAttribute('data-message-caret');
    this.selectorItemCount = this.el.getAttribute('data-messages-count');
    this.msgsBubble = document.getElementById('navbar-info-bubble');
    // Get first message of the list onload.
    // console.log('this.selectorItems.length');
    // console.log(this.selectorItems.length);
    if (this.selectorItemCount > 0) {
      this.msgID = document.querySelectorAll(this.selectorItems)[0].id;
      this.dest = document.querySelector(this.selectorView);
      this.items = $(this.selectorItemCaret).parents('li');
      this.body = $('body');
      // this.selectLeft = $('select#move-left');
      this.selectLeft = document.querySelector('#move-to-parent');
      // this.selectRight = $('select#move-right');
      this.init();
      document.getElementById(this.msgID).click();
    }
  }

  /* eslint-disable class-methods-use-this */
  init() {
    // console.log('messages > init');
    if (this.items.length) {
      // this._getMsg(this.msgID);
      this.body.on('click', `${this.selectorItems}`, item => {
        if (this.msgsBubble !== null) {
          this.msgsBubbleState = parseInt(this.msgsBubble.innerHTML, 10);
        } else {
          this.msgsBubbleState = 0;
        }
        if (item.target.type !== 'checkbox') {
          this._getMsg(item.currentTarget.id);
          if (this.msgsBubbleState > 0) {
            this.msgsBubble.innerHTML = this.msgsBubbleState - 1;
          }
        }
      });
    }
  }

  /* eslint-disable class-methods-use-this */
  _getMsg(mid) {
    const msgLi = $(`li#${mid}`);
    const msgLiI = msgLi.find('i');
    // Set background color.
    $(this.selectorItems).removeClass('is-active');
    // Change status symbol.
    msgLi.addClass('is-active');
    msgLiI.removeClass('fa-envelope').addClass('fa-envelope-o');
    $.post(
      '/message_ajax.php',
      {
        id: mid
      },
      html => {
        this.dest.innerHTML = html;
      }
    );
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/messages.js